module.exports = __webpack_public_path__ + "img/404.dbbd2171.png";